import { Ministry, Testimonial, Quiz } from '../types';

export const ministries: Ministry[] = [
  {
    id: '1',
    name: 'Healing Party',
    url: "healing-party/",
    description: 'Empowering young people to grow in faith'
  },
  {
    id: '2', 
    name: 'Bible Study',
    url: "bible-study/",
    description: 'Leading hearts to worship through music'
  },
  {
    id: '3',
    name: 'Life In The Spirit',
    url: "life-in-the-spirit/",
    description: 'Interceding for the body of Christ'
  },
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    author: 'Sarah Johnson',
    content: 'Through the youth ministry, I discovered my purpose in Christ. The mentorship and biblical teaching transformed my life completely. I went from feeling lost to having a clear direction and deep relationship with Jesus.',
    ministryId: '1',
    ministry: 'Youth Ministry',
    likes: 24,
    isPinned: true,
    createdAt: new Date('2024-01-15'),
    liked: false
  },
  {
    id: '2',
    author: 'Michael Chen',
    content: 'The worship ministry taught me that worship isn\'t just about singing - it\'s about living a life that honors God. Every practice session became a time of spiritual growth and community building.',
    ministryId: '2',
    ministry: 'Worship Ministry', 
    likes: 18,
    isPinned: false,
    createdAt: new Date('2024-01-10'),
    liked: true
  },
  {
    id: '3',
    author: 'Grace Williams',
    content: 'Prayer ministry opened my eyes to the power of intercession. I\'ve witnessed miraculous healings and breakthroughs that can only come from God. My faith has grown exponentially.',
    ministryId: '3',
    ministry: 'Prayer Ministry',
    likes: 32,
    isPinned: true,
    createdAt: new Date('2024-01-08'),
    liked: false
  },
  {
    id: '4',
    author: 'David Martinez',
    content: 'Joining the outreach ministry challenged me to step out of my comfort zone. Sharing the gospel on the streets taught me boldness and compassion for the lost.',
    ministryId: '4',
    ministry: 'Outreach Ministry',
    likes: 15,
    isPinned: false,
    createdAt: new Date('2024-01-05'),
    liked: false
  }
];

export const quizzes: Quiz[] = [
  {
    id: '1',
    title: 'Biblical Foundations',
    description: 'Test your knowledge of core Christian doctrines',
    questions: [
      {
        id: '1',
        type: 'multiple-choice',
        question: 'The Bible consists of _____ books.',
        options: ['64', '66', '68', '70'],
        correctAnswer: '66',
        explanation: 'The Bible contains 66 books: 39 in the Old Testament and 27 in the New Testament.'
      },
      {
        id: '2', 
        type: 'fill-blank',
        question: 'For God so loved the world that he gave his one and only _______, that whoever believes in him shall not perish but have eternal life.',
        correctAnswer: 'Son',
        explanation: 'John 3:16 - This verse encapsulates the heart of the gospel message.'
      },
      {
        id: '3',
        type: 'multiple-choice',
        question: 'Which disciple denied Jesus three times?',
        options: ['John', 'Peter', 'Thomas', 'Judas'],
        correctAnswer: 'Peter',
        explanation: 'Peter denied knowing Jesus three times before the rooster crowed, just as Jesus had predicted.'
      }
    ]
  }
];

export const dailyDeclarations = [
  "I am fearfully and wonderfully made in God's image (Psalm 139:14)",
  "I can do all things through Christ who strengthens me (Philippians 4:13)",
  "God has plans to prosper me and not to harm me (Jeremiah 29:11)",
  "I am more than a conqueror through Christ (Romans 8:37)",
  "His grace is sufficient for me in all things (2 Corinthians 12:9)"
];